import { gql } from '@apollo/client';

// Hand-written beside the generated documents: `npm run generate` rewrites queries.ts and mutations.ts, never this file.

const BATCH_TRACKING_BATCH_FIELDS = gql`
  fragment BatchTrackingBatchFields on BatchV2 {
    id
    labelId
    itemType
    itemId
    itemName
    quantity
    unit
    parentId
    supplierRef
    balance
    childCount
    createdAt
    deletedAt
    editableUntil
  }
`;

export const BATCH_TRACKING_BATCHES_QUERY = gql`
  ${BATCH_TRACKING_BATCH_FIELDS}
  query BatchTrackingBatches(
    $kitchen: Kitchen!
    $from: AWSDate!
    $to: AWSDate!
    $itemId: String
    $accountId: String
    $limit: Int
    $next: String
  ) {
    listBatchesV2(kitchen: $kitchen, from: $from, to: $to, itemId: $itemId, accountId: $accountId, limit: $limit, next: $next) {
      items {
        ...BatchTrackingBatchFields
      }
      next
    }
  }
`;

const BATCH_TRACKING_ACTIVITY_COUNTS = gql`
  fragment BatchTrackingActivityCounts on BatchActivityCountsV2 {
    rootBatches
    splitBatches
    deletedBatches
    liveBatches
  }
`;

export const BATCH_TRACKING_ACCOUNT_ACTIVITY_QUERY = gql`
  ${BATCH_TRACKING_ACTIVITY_COUNTS}
  query BatchTrackingAccountActivity($kitchen: Kitchen!, $from: AWSDate!, $to: AWSDate!) {
    getBatchAccountActivityV2(kitchen: $kitchen, from: $from, to: $to) {
      kitchen
      from
      to
      asOf
      bucketSize
      summary {
        recordingAccounts
        user {
          ...BatchTrackingActivityCounts
        }
      }
      device {
        ...BatchTrackingActivityCounts
      }
      accounts {
        accountId
        label
        rootCount
        splitCount
        deletedCount
        liveCount
        lastRecordedAt
      }
      trend {
        start
        userCreations
        deviceCreations
      }
    }
  }
`;

export const BATCH_TRACKING_BATCH_QUERY = gql`
  ${BATCH_TRACKING_BATCH_FIELDS}
  query BatchTrackingBatch($kitchen: Kitchen!, $id: String!) {
    getBatchV2(kitchen: $kitchen, id: $id) {
      batch {
        ...BatchTrackingBatchFields
      }
      label {
        id
        printedAt
      }
      children {
        ...BatchTrackingBatchFields
      }
    }
  }
`;

export const BATCH_TRACKING_SCAN_LABEL_MUTATION = gql`
  ${BATCH_TRACKING_BATCH_FIELDS}
  mutation BatchTrackingScanLabel($input: ScanLabelInput!) {
    scanLabel(input: $input) {
      batch {
        ...BatchTrackingBatchFields
      }
    }
  }
`;

export const BATCH_TRACKING_DELETE_BATCH_MUTATION = gql`
  mutation BatchTrackingDeleteBatch($kitchen: Kitchen!, $id: String!) {
    deleteBatchV2(kitchen: $kitchen, id: $id) {
      id
    }
  }
`;

export const BATCH_TRACKING_HOME_BATCHES_QUERY = gql`
  ${BATCH_TRACKING_BATCH_FIELDS}
  query BatchTrackingHomeBatches($kitchen: Kitchen!, $day: AWSDate!) {
    listHomeBatchesV2(kitchen: $kitchen, day: $day) {
      ...BatchTrackingBatchFields
    }
  }
`;

export const BATCH_TRACKING_TRACKABLE_ITEMS_QUERY = gql`
  query BatchTrackingTrackableItems($input: ListTrackableItemsInput) {
    listTrackableItems(input: $input) {
      id
      name
      kind
      unit
    }
  }
`;

export const BATCH_TRACKING_CREATE_BATCH_MUTATION = gql`
  ${BATCH_TRACKING_BATCH_FIELDS}
  mutation BatchTrackingCreateBatch($input: CreateBatchV2Input!) {
    createBatchV2(input: $input) {
      ...BatchTrackingBatchFields
    }
  }
`;

export const BATCH_TRACKING_UPDATE_BATCH_MUTATION = gql`
  ${BATCH_TRACKING_BATCH_FIELDS}
  mutation BatchTrackingUpdateBatch($input: UpdateBatchV2Input!) {
    updateBatchV2(input: $input) {
      ...BatchTrackingBatchFields
    }
  }
`;
